import React, { useContext } from 'react';
import alert from '@components/alert';

import { INPUT_COMPS } from '../formItems';

import { ConfigContext } from './formList';

const isFunction = (item) => typeof item === 'function';

const formatRules = ({ rules, wrapperName }) =>
  rules.map((rule) => {
    if (isFunction(rule)) {
      const result = rule([wrapperName]);

      if (isFunction(rule)) {
        return result;
      }
      return rule;
    }
    return rule;
  });

export function Cell(props) {
  const configs = useContext(ConfigContext);
  const {
    childProps,
    cellProps: { style, inputType, className },
  } = props;
  if (Object.keys(configs).length > 1) {
    childProps.inputProps.config = configs;
  }
  // console.log(childProps.inputProps.formInstance.getFieldsValue());
  const Comp = INPUT_COMPS[inputType];

  return (
    <div style={style} className={`cell ${className || ''}`}>
      <Comp {...childProps} />
    </div>
  );
}

export const renderCells =
  ({
    field,
    isActive,
    onRowDelete,
    onDragHandlerClick,
    name: wrapperName,
    rowKey,
    formInstance,
    formData,
    refreshCount,
    formChange,
    projHomeExtraForm,
    multiSectionExtraForm,
  }) =>
  ({
    formConfig: { rules = [], inputType, ...restConfig },
    style = {},
    key,
    className,
  }) => {
    const _rules = formatRules({
      rules,
      wrapperName,
    });
    const rowIndex = field.name;
    const handleRowDeleteClick = () => {
      const removeRow = formInstance.__moduleListRemove;
      if (typeof removeRow === 'function') {
        removeRow(rowIndex);
        formInstance.__moduleListFormChange?.();
        return;
      }
      onRowDelete?.(rowKey, rowIndex);
    };
    const childProps = {
      formData,
      field,
      rules: _rules,
      fieldKey: [field.fieldKey, key],
      name: [field.name, key],
      inputProps: {
        shouldExtend: isActive,
        className: 'textarea-extendable',
        onRowDelete: handleRowDeleteClick,
        onDragHandlerClick,
        rowIndex,
        listFieldKey: rowKey,
        rowName: wrapperName,
        formInstance,
        refreshCount,
        ...restConfig,
        formChange,
      },
    };
    const cellProps = {
      style,
      inputType,
      className,
    };

    const customizedModule =
      formInstance.getFieldValue('customizeModule') || {};
    const isCellInProjectHomeRow =
      (customizedModule[childProps.inputProps.rowIndex] || {}).module ===
      'Project Home';
    const isCellInMultiSection =
      (customizedModule[childProps.inputProps.rowIndex] || {}).type ===
      'multiSection';
    const shouldBeHidInProjHomeRow =
      ['drag', 'module'].indexOf((childProps?.fieldKey || [])[1]) === -1;
    const shouldBeHidInMultiSectionRow =
      ['drag', 'module', 'type', 'iframe', 'icon', 'id'].indexOf(
        (childProps?.fieldKey || [])[1],
      ) === -1;

    // 自定义删除按钮
    const customDeleteBtn =
      (canDelete) =>
      ({ confirmDelete }) =>
        (
          <div
            style={{ color: '#E45C2B', cursor: 'pointer' }}
            onClick={() => {
              if (canDelete) {
                confirmDelete();
              } else {
                alert.error('You have to delete all the sections first.');
              }
            }}
          >
            Delete Module
          </div>
        );
    // multiple section的展示列
    if (isCellInMultiSection && multiSectionExtraForm) {
      const values =
        childProps?.inputProps?.formInstance?.getFieldsValue()?.customizeModule;
      // multiple section是否显示module删除按钮的判断
      if (!values[childProps.field.name]?.multiSectionList?.length) {
        childProps.inputProps.customEle = customDeleteBtn(true); // 可以删除
      } else {
        childProps.inputProps.customEle = customDeleteBtn(false); // 不可以删除
      }
    }
    const shouldBeReplacedInProjectHomeRow =
      (childProps?.fieldKey || [])[1] === 'type';
    const shouldBeReplacedInMultiSectionRow =
      (childProps?.fieldKey || [])[1] === 'ratio';

    const cell = (
      <Cell
        key={`${key}-${field.key}`}
        cellProps={cellProps}
        childProps={childProps}
      />
    );

    if (!projHomeExtraForm && !isCellInMultiSection) {
      return cell;
    }

    if (isCellInProjectHomeRow && shouldBeReplacedInProjectHomeRow) {
      return projHomeExtraForm;
    }

    if (
      isCellInMultiSection &&
      shouldBeReplacedInMultiSectionRow &&
      multiSectionExtraForm
    ) {
      // console.log('field: ', field, rowKey, childProps);
      return (
        <div key={`${key}-${field.key}`}>{multiSectionExtraForm(field)}</div>
      );
    }

    if (
      (isCellInProjectHomeRow && shouldBeHidInProjHomeRow) ||
      (isCellInMultiSection &&
        shouldBeHidInMultiSectionRow &&
        multiSectionExtraForm)
    ) {
      return null;
    }

    return cell;
  };

export default Cell;
